module.exports = __webpack_public_path__ + "static/media/calendar-outlook.d0a4602c.png";